var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cytomine-modal-card',{attrs:{"title":_vm.$t('how-to-use')},on:{"close":function($event){return _vm.$parent.close()}}},[_c('how-to-use')],1)}
var staticRenderFns = []

export { render, staticRenderFns }